var map = {
	"./Butterfly_monarch.jpg": 7154,
	"./Butterfly_monarch_001.jpg": 5347,
	"./Butterfly_monarch_002.jpg": 6190,
	"./Butterfly_monarch_003.jpg": 6397,
	"./Butterfly_monarch_004.jpg": 2170,
	"./Vertical_ButterflyWings_01.jpg": 9393,
	"./Vertical_ButterflyWings_03.jpg": 4276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3406;